import React from "react";

// A pitch text annotation. Rendered inside the rotated pitch group so it
// follows the pitch orientation. The visible glyphs counter-rotate by the
// current pitch rotation so text remains upright for the reader.
export const PitchText = ({ text, isSelected, pitchRotation = 0, onPointerDown }) => {
  const size = typeof text.size === "number" ? text.size : 1;
  const fontSize = 22 * size;
  const color = text.color || "#0F172A";
  const rotation = typeof text.rotation === "number" ? text.rotation : 0;
  // Combine user-set rotation with the inverse of the pitch rotation.
  const glyphRotation = rotation - pitchRotation;

  const commonProps = {
    onPointerDown: (e) => {
      e.stopPropagation();
      onPointerDown(e, text.id);
    },
    style: { cursor: "grab", touchAction: "none" },
    "data-testid": `text-${text.id}`,
  };

  const content = text.content || "Text";
  // Approximate padded halo for selection ring — width based on char count.
  const halfW = Math.max(30, content.length * fontSize * 0.32);
  const halfH = fontSize * 0.7;

  return (
    <g transform={`translate(${text.x} ${text.y})`} {...commonProps}>
      {isSelected && (
        <rect
          x={-halfW - 6}
          y={-halfH - 4}
          width={halfW * 2 + 12}
          height={halfH * 2 + 8}
          rx={6}
          fill="none"
          stroke="#10B981"
          strokeWidth={2}
          strokeDasharray="4 3"
          pointerEvents="none"
        />
      )}
      <g transform={`rotate(${glyphRotation})`}>
        {/* Soft white halo behind the text so it remains readable on the pitch */}
        <text
          x={0}
          y={0}
          dy="0.35em"
          textAnchor="middle"
          fill="#FFFFFF"
          stroke="#FFFFFF"
          strokeWidth={fontSize * 0.35}
          strokeLinejoin="round"
          paintOrder="stroke"
          fontSize={fontSize}
          fontWeight="700"
          fontFamily="Manrope, sans-serif"
          opacity={0.85}
        >
          {content}
        </text>
        <text
          x={0}
          y={0}
          dy="0.35em"
          textAnchor="middle"
          fill={color}
          fontSize={fontSize}
          fontWeight="700"
          fontFamily="Manrope, sans-serif"
        >
          {content}
        </text>
      </g>
    </g>
  );
};
